export default "__VITE_ASSET__2e221532__"